import React from 'react';
import Card from './Card';
import {robots} from './robots'
import netflix from "./netflix.png"
import gradient from "./gradient.jpeg"
import googlePic from "./google.png"
import "./projectApp.css"
const Projects = () => {
  return (
    <div className="tc">
      <h1 className='projects'>Projects</h1>
      <Card img={netflix} name={robots[0].name} info={robots[0].username} github={robots[0].github} website={robots[0].website}/>
      <Card img={gradient} name={robots[1].name} info={robots[1].username} github={robots[1].github} website={robots[1].website}/>
      <Card img={googlePic} name={robots[2].name} info={robots[2].username}github={robots[2].github} website={robots[2].website}/>
    </div>
  )
}
 
 
 
 
export default Projects;